import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue, mapRelationalValue } from "../../utils/filters";
import { IUser, IUserResource } from "../types";

export interface IUserPatchTutorsParameters {
    user: RelationalValue<IUserResource>;
    tutorsAsLearner: Array<{
        email: string;
        name?: string;
        surname?: string;
    }>;
}

export type IUserPatchTutorsMutationResult = IUser;

export const userPatchTutorsMutation: IApiMutationFunction<IUserPatchTutorsParameters> = ({
    user,
    tutorsAsLearner,
}) => {
    return {
        method: "PATCH",
        url: `/users/${mapRelationalValue(user)}`,
        data: { tutorsAsLearner },
        headers: { "Content-Type": "application/merge-patch+json" },
    };
};

export const useUserPatchTutorsMutation = createApiMutationHook<
    IUserPatchTutorsParameters,
    IUserPatchTutorsMutationResult
>(userPatchTutorsMutation);
